/*
* @Author: huangshuo
* @Date: 2020-2-18 11:49:00
*/
<template>
  <div
    class="filelist-item"
    :class="[`isfolder-${currentData.isDir}`, {'item-selected': currentData.checked}]"
  >
    <!--列表主题-->
    <div
      ref="fileItem"
      class="filelist-item-inner"
      :class="[{'hover': isShowOperation},{'card-mode': !currentData.is_dir}]"
      @mouseenter="mouseenterHandler"
      @mouseleave="mouseleaveHandler"
      @dblclick="dblclickHandler"
      @mouseup="clickHandler"
    >
      <div class="clearfloat">
        <!-- 文件列表复选框 -->
        <div
          v-if="headerInfo.checkbox"
          ref="checkbox"
          class="box-checkbox"
          :class="isDisabled? 'checkbox-disabled-div':''"
        >
          <span
            class="box-checkbox-inner"
            :class="[isDisabled? '': currentData.checked? 'checkbox-checked': '', isDisabled? 'checkbox-disabled-click':'']"
          />
        </div>

        <!-- 列表每一条记录的内容 -->
        <div
          ref="fileitem"
          class="filelist-item-inner-blocks"
        >
          <template v-for="(list, j) in currentData.data">
            <!-- 文件名里的内容-->
            <div
              v-if="list.type == 'file'"
              ref="fileinfo"
              :key="j"
              :class="`item-${j} filelist-icon ${list.class} file-item-info`"
              :style="`width:${!listDrageStylesResize?listDragStyles.get(j):''}`"
            >
              <!--文件列表内容区域, 删除了action-list.action的值永远为undefined-->
              <div
                ref="filrArea"
                :class="'file-area'"
              >
                <!--(list.custom && list.custom.icon)这个class永远获取不到，没有意义，class永远都是file-icon-->
                <svg :class="'file-icon'">
                  <use
                    ref="fileicon"
                    :xlink:href="getIcon(currentData)"
                  />
                </svg>

                <!--列表信息部分-->
                <div
                  ref="fileInfoSpan"
                  class="file-info"
                >
                  <span class="file-name">
                    <!--如果文件不存在，显示tooltipsj进行提示,否则显示a链接进行展示-->
                    <el-tooltip
                      v-if="noExist"
                      class="item"
                      effect="dark"
                      :content="currentData.is_dir?$t('文件夹不存在'):$t('文件不存在')"
                      placement="top"
                    >
                      <a
                        v-if="!list.showRename"
                        ref="name"
                        class="display-name"
                        :class="[getAdaptWidth]"
                        :title="list.value | filterHtml"
                        v-html="formateName(list.value)"
                      />
                    </el-tooltip>
                    <a
                      v-else-if="!list.showRename"
                      ref="name"
                      class="display-name"
                      :title="list.value | filterHtml"
                      :class="[getAdaptWidth, currentData.canPreivew? '':currentData.is_dir?'':'no-preview']"
                      v-html="formateName(list.value)"
                    />
                    <!--列表模式显示文件病毒-->
                    <span
                      v-show="haveVirus && !list.showRename && !currentData.is_dir"
                      class="virus-icon"
                    >{{ $t('病毒') }}</span>
                    <!--文件其他图标属性的插槽-->
                    <slot
                      v-if="isShowIconGroup && !list.showRename"
                      name="icongroup"
                      :data="{currentData, index, otherData: $data}"
                    />
                  </span>
                  <slot
                    v-if="!list.showRename"
                    name="tag"
                  />
                  {{ list.others || '' }}
                </div>
              </div>
            </div>
            <!--显示日期时间和文件大小-->
            <div
              v-else
              v-show="!isShowOperation"
              :key="j"
              :class="`item-${j} ${list.class} file-item-info`"
              :style="`width:${!listDrageStylesResize?listDragStyles.get(j):''}`"
              :title="list.title"
              v-html="list.value"
            />
            <!--添加操作项插槽-->
            <slot
              v-if="list.type == 'file'"
              name="operation"
              :data="{currentData, index, operationState, otherData: $data}"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import * as Util from 'js/util/util.js'
import mixin from './mixin.js'

export default {
  components: {},
  mixins: [mixin],
  props: {
    // 列表模式拖动
    listDragStyles: Map,
    // 列表模式拖动
    listDrageStylesResize: Boolean,
    // 列表模式拖动
    fileItemIconWidthCache: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      defaultMaxWidth: undefined, // 拖动
      hoverMaxWidth: undefined, // 拖动
      defaultMaxWidthCache: undefined, // 拖动
      hoverMaxWidthCache: undefined, // 拖动
    }
  },
  computed: {
    /**
         * 操作按钮的状态
         */
    operationState() {
      return (this.selectedData.length > 1) ? !this.currentData.checked && this.isShowOperation : this.isShowOperation
    },
    /** 根据不同的图标显示不同的宽度 */
    getAdaptWidth() {
      let count = 0; let
        adaptWidthClass = ''
      if (this.haveVirus) count++
      if (this.haveFavorite) count++
      if (this.currentData.has_docs_lock) count++
      if (this.currentData.lock_uid) count++

      switch (count) {
        case 1:
          adaptWidthClass = 'one-icon'
          break
        case 2:
          adaptWidthClass = 'two-icon'
          break
        case 3:
          adaptWidthClass = 'three-icon'
          break
        case 4:
          adaptWidthClass = 'four-icon'
          break
        default:
          break
      }
      if (this.haveVirus) adaptWidthClass += '-virus'
      return adaptWidthClass
    },
  },
  watch: {
    /**
         * 拖动相关
         */
    fileItemIconWidthCache(val, oldVal) {
      // 拖拽改变后根据fileItemIconWidthCache值的变化进行默认值的变动 val===0 代表拖动的不是文件名列
      if (val === 0) {
        this.defaultMaxWidth = this.defaultMaxWidthCache
        this.hoverMaxWidth = this.hoverMaxWidthCache
      } else {
        const operateW = Util.getWidthOrHeight(this.$el.querySelector('.file-operate'), 'width')
        this.defaultMaxWidth = `${val}px`
        this.hoverMaxWidth = `${val - operateW - 12}px`
      }
    },
    /**
         *内嵌操作栏在改变状态之后重新计算位置
         */
    showOperation(val) {
      // 在dom未完成之前 calcNameMaxWidth()计算有问题，所以需要在nextTick后调用。
      this.$nextTick(() => {
        this.calcNameMaxWidth()
      })
    },
  },
  mounted() {
    // 挂载阶段计算各个宽度
    this.$nextTick(() => {
      this.calcNameMaxWidth()
    })
  },
  methods: {
    /**
         * 鼠标经过事件
         */
    mouseenterHandler() {
      // 这个hoverNeid抛出后,在重新传入，与当前currentData.neid做对比
      this.$emit('setHoverNeid', this.currentData)
      if (this.currentData.checked) {
        // 多个文件被选中，不现实操作菜单
        this.showOperation = !(this.selectFile.data.length >= 2)
      } else {
        // 单文件选中移动到该文件显示操作菜单
        this.showOperation = true
      }
    },
    /**
         * 鼠标离开事件
         */
    mouseleaveHandler(e) {
      // 遮罩部分
      if (this.isShowMask) return
      // 隐藏操作项目
      this.showOperation = false
      // 设置名称长度
      this.nameMaxWidth = `${parseInt(this.nameMaxWidth) + this.defaultOperationWidth}px`
    },
    /**
         * 计算名称的宽度
         */
    calcNameMaxWidth() {
      // 大图或ie9
      if (!this.isListMode) {
        this.hoverMaxWidth = '33%'
        return
      }
      // 计算各个宽度
      const el = this.$el
      const refs = this.$refs
      const iconW = Util.getWidthOrHeight(el.querySelector('.file-absolute'), 'width')
      const operateW = Util.getWidthOrHeight(el.querySelector('.file-operate'), 'width')
      const { fileitem } = refs
      const fileinfo = refs.fileinfo[0]
      const name = refs.name[0]
      const infoW = fileinfo.offsetWidth
      const { left: nameL } = Util.getOffsetTopLeft(name, fileitem)
      const width = infoW - nameL - iconW
      this.defaultMaxWidth = `${(width - 40) / infoW * 10000 / 100}%`
      this.hoverMaxWidth = `${(width - operateW - 12) / infoW * 10000 / 100}%`
      // 缓存初始计算的最大宽度和hover最大宽
      this.defaultMaxWidthCache = `${(width - 40) / infoW * 10000 / 100}%`
      this.hoverMaxWidthCache = `${(width - operateW - 12) / infoW * 10000 / 100}%`
    },
  },
}
</script>
<style lang="less" scoped>
@import "~less/file.less";

//checkbox禁止点击
.checkbox-disabled-click {
  pointer-events:none;
  border:1px solid #C1C7CD;
  background-color:#F6F7FA;
}
.checkbox-disabled-div {
  pointer-events:none;
}

//列表样式
.filelist-item {
  &.item-selected {
    background-color: #E7F0FF;
    .font-icon {
      display: inline-block;
      font-size: 14px;
      top: 0;
      left: -9px;
    }
    .filelist-item-inner{
      &:hover{
        background-color: #E7F0FF;
      }
    }
  }

  //列表样式
  .filelist-item-inner{
    min-height: 60px;
    line-height: 60px;
    color: @darkGray;
    font-size: 14px;
    transition: height 0.5s;
    position: relative;
    display: block;
    &:hover{
      background: @hoverGray;
    }
    &.drag-enter{
      background-color: @hoverGray;
    }
    &.extend {
      height: auto;
      min-height: 52px;
      .item-tag {
        height: auto;
      }
    }

    .filelist-item-inner-blocks {
      position: relative;
      height: 52px;
      padding-left: 35px;
      padding-right: 8px;
      &::after {
        content: '';
        display: block;
        width: 0px;
        height: 0px;
        visibility: hidden;
        clear: both;
      }
      .file-item-info {
        position: relative;
        float: left;
        height: 100%;
        .file-area {
          width: 100%;
          .file-icon {
            float: left;
            width: 24px;
            height: 24px;
            margin: 18px 15px 0 0;
          }
          .icon-file-link {
            //background: url(~image/file-list/linkicon.svg) no-repeat;
            float: left;
            background-size: 22px 22px;
            background-position: 0 0;
          }
          .file-info {
            display: inline-block;
            line-height: normal;
            vertical-align: middle;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            box-sizing: border-box;
            margin-left: -39px;
            padding-left: 39px;
            a.display-name {
              cursor: pointer;
              color: #1B2733;
              display: inline-block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              vertical-align: top;
              max-width: calc(100% - 25px);
              height: 20px;
              line-height: 20px;
              &:hover {
                text-decoration: underline;
              }
              &.delivery{
                color: @mainColor;
              }
              &.delete{
                cursor: initial;
                color: @deleteColor;
              }
              &.isclient {
                text-decoration: none;
                cursor: default;
              }
            }
            a.one-icon{
              max-width: calc(100% - 50px);
            }
            a.two-icon{
              max-width: calc(100% - 75px);
            }
            a.three-icon{
              max-width: calc(100% - 100px);
            }
            a.four-cion{
              max-width: calc(100% - 100px);
            }
            a.one-icon-virus{
              max-width: calc(100% - 75px);
            }
            a.two-icon-virus{
              max-width: calc(100% - 100px);
            }
            a.three-icon-virus{
              max-width: calc(100% - 125px);
            }
            a.four-cion-virus{
              max-width: calc(100% - 125px);
            }
            span.virus-icon {
              position: relative;
              top: 1px;
              height: 16px;
              line-height: 16px;
              border: 1px solid #FF1B43;
              font-size: 12px;
              color: #FF1B43;
              padding: 0 4px 0 4px;
              margin-left: 8px;
              border-radius: 2px;
              vertical-align: top;
              display: inline-block;
            }
            .file-absolute {
              display: inline-block;
              vertical-align: top;
              .favorite-icon {
                position: relative;
                top: 1px;
                display: inline-block;
                visibility: hidden;
                width: 16px;
                height: 16px;
                margin-left: 4px;
                //background: url(~image/favoriteBox/star.svg) no-repeat;
                cursor: pointer;
                &.favorited {
                  display: inline-block;
                  visibility: visible;
                  //background-image: url(~image/favoriteBox/starl.svg);
                }
              }
              .lock-icon {
                position: relative;
                top:1px;
                display: none;
                width: 14px;
                height: 16px;
                //background: url(~image/file-list/file-operate.png) -48px -87px;
                &.locked {
                  display: inline-block;
                }
              }
              .edit-ol-icon {
                position: relative;
                top: 1px;
                display: none;
                width: 14px;
                height: 14px;
                //background: url(~image/file-list/edit-ol.gif) no-repeat;
                cursor: pointer;
                &.edited {
                  display: inline-block
                }
              }
            }
          }
        }
      }
    }
  }

  &.hover .file-item-info .file-area .file-info .file-absolute .favorite-icon {
    display: inline-block;
    visibility: visible;
  }
}

//不可预览没有下划线和小手
.no-preview{
  cursor: default !important;
  text-decoration: none !important;
}


</style>
